import { useFeatureFlags } from 'src/context/FeatureFlagsContext';
import { V2Adapter } from 'src/v2/desktop/V2Adapter';
import { AuditsPage as V2AuditsPage } from 'src/v2/mobile/pages/AuditsPage';
import AuditsPage from './AuditsPage';

/**
 * Route-level gate for the Audits list page.
 *
 * When `enableV2Desktop` is true, renders the V2 Stencil audit list
 * inside the V2Adapter (design tokens + auth bridge + error boundary).
 * Otherwise, renders the legacy Cloudscape table page.
 *
 * This is the E2 page gate from the parity analysis doc.
 */
export function AuditsPageGate(): JSX.Element {
  const { enableV2Desktop } = useFeatureFlags();

  if (enableV2Desktop) {
    return (
      <V2Adapter>
        <V2AuditsPage />
      </V2Adapter>
    );
  }

  return <AuditsPage />;
}
